import useDelete from './useDelete.jsx';
import { setEventTypesQuery } from './Queries';
import * as Toast from './Toast.js';
import useBusinessPostApi from './useBusinessPostApi.js';
import useBusinessNavigate from './useBusinessNavigate.js';

export function useDoDeleteEventType(id) {
    const { saveDelete, isDeleting } = useDelete(`/event-types/${id}/delete`);
    const navigate = useBusinessNavigate();

    function doDelete() {
        saveDelete().then(result => {
            setEventTypesQuery(result, true);
            navigate(`/scheduling/event-types`);
            Toast.success('Successfully deleted event type');
        });
        return true;
    }

    return {
        doDelete,
        isDeleting,
    };
}

export function useDoDuplicateEventType(id) {
    const { save: saveDuplicate, isSaving: isDuplicating } = useBusinessPostApi(
        `/event-types/${id}/duplicate`,
    );
    const navigate = useBusinessNavigate();

    function doDuplicate() {
        saveDuplicate({}).then(result => {
            setEventTypesQuery(result.allTypes, true);
            navigate(`/scheduling/event-types/${result.newType.id}`);
            Toast.success('Successfully duplicated event type');
        });
        return true;
    }

    return {
        doDuplicate,
        isDuplicating,
    };
}
